import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Bell } from 'lucide-react';
import { useNotifications } from '../../context/NotificationContext';
import NotificationPanel from './NotificationPanel';

// จอเล็กกว่า md (768px) ของ Tailwind ให้ไปหน้าเต็มแทน popover ซึ่งวางยากบนจอแคบ
const MOBILE_BREAKPOINT = 768;

const NotificationBell: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onEscape = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onEscape);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onEscape);
    };
  }, [open]);

  const handleClick = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      navigate('/notifications');
      return;
    }
    setOpen((v) => !v);
  };

  return (
    <div className={`relative ${className}`} ref={rootRef}>
      <button
        type="button"
        aria-label="การแจ้งเตือน"
        onClick={handleClick}
        className="relative flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full shadow transition-transform active:scale-90"
        style={{ backgroundColor: 'var(--button-userbox)', color: 'var(--text-color)' }}
      >
        <Bell size={18} />
        {unreadCount > 0 && (
          <span
            className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center text-white transition-transform"
            style={{ backgroundColor: 'var(--red-text-color-btn, #ef4444)' }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
      <AnimatePresence>
        {open && <NotificationPanel key="panel" onClose={() => setOpen(false)} />}
      </AnimatePresence>
    </div>
  );
};

export default NotificationBell;
